import { useEffect } from 'react';
import { Flex, Margin } from 'components/base/layout-components';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';
import { SPACES } from 'common/constants/sizes';
import { TRACKING } from 'common/constants/constants';
import * as TrackingService from 'common/services/tracking.service';
import { LBButton, LBInput } from '@linearb/buzz';

const JiraConnectStep1 = props => {
  const {
    value,
    allowContinue,
    allowInput,
    errorMessage,
    onContinue,
    onChange
  } = props;

  useEffect(() => {
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.SETTINGS,
      page_tab: TRACKING.PAGE_TABS.JIRA,
      click_type: TRACKING.CLICK.SETUP_PM_CONNECT_START
    });
  }, []);

  const renderErrorIfNeeded = () => {
    const { errorMessage = null, onContinue, nat_gateway_ips } = props;

    if (errorMessage) {
      return (
        <>
          <Text size='large' color='gray' pt='2rem'>
            In order to connect successfully to your Jira server, make sure your
            organization’s firewall allows
          </Text>
          <Text size='large' color='gray'>
            communications in/out the following IP addresses: {nat_gateway_ips}
          </Text>
          <Margin t='medium'>
            <LBButton onClick={onContinue} size='lg'>
              Test Connection
            </LBButton>
          </Margin>
          <Flex
            justify='space-between'
            content='flex-start'
            items='center'
            pt='small'
          >
            <Icon name='ChangeHistory' color='torchRed' />
            <Text color='torchRed' size='large'>
              {errorMessage}
            </Text>
          </Flex>
        </>
      );
    }
  };

  return (
    <Flex
      justify='space-between'
      content='flex-start'
      items='flex-start'
      direction='column'
    >
      <Text size='large' color='abbey' weight='500' pb={SPACES.medium}>
        STEP 1
      </Text>
      <Text size='large' color='gray' pb='1rem'>
        Paste the Base URL from your Jira account.
      </Text>
      <Text size='large' color='gray' pb='0.5rem'>
        If you are using Jira cloud, your base URL will look like:
        https://company_name.atlassian.net
      </Text>
      <Text size='small' color='gray' pb='0.4rem' pl='0.2rem'>
        Jira Base URL
      </Text>
      <LBInput
        placeholder='https://[your_company].atlassian.net'
        onChange={event => onChange(event.target.value)}
        disabled={!allowInput}
        className='w-[440px]'
        value={value || undefined}
      />
      <Margin t='medium'>
        <LBButton
          disabled={!allowContinue || !!errorMessage}
          onClick={onContinue}
          size='lg'
        >
          Continue
        </LBButton>
      </Margin>
      {renderErrorIfNeeded()}
    </Flex>
  );
};

export default JiraConnectStep1;
